function getOrderLocalId(order) {
  return order && (order.Id || order.id || order.stripeSessionId || order.orderId);
}

function canLinkExistingUser(order) {
  if (!order || order.source !== "Stripe" || order.UserId || order.userMatch) {
    return false;
  }

  if (!order.purchaseType) {
    return false;
  }

  return order.purchaseType === "pas" || Boolean(order.targetId);
}

function buildLinkExistingUserPayload(order, userId) {
  return {
    purchaseType: order && order.purchaseType,
    targetId: order && order.targetId ? order.targetId : "",
    userId,
  };
}

function normalizeUserSearchResults(response) {
  if (Array.isArray(response)) {
    return response;
  }

  if (response && Array.isArray(response.docs)) {
    return response.docs;
  }

  return [];
}

function formatSecondaryEmails(user) {
  return Array.isArray(user && user.secondaryEmails)
    ? user.secondaryEmails
        .filter((entry) => entry && entry.email)
        .map((entry) => {
          const details = [entry.type, entry.source].filter(Boolean).join(", ");
          return details ? `${entry.email} (${details})` : entry.email;
        })
    : [];
}

function normalizePrefillEmail(email) {
  return typeof email === "string" ? email.trim() : "";
}

function isUsableName(name, email) {
  if (typeof name !== "string") {
    return false;
  }

  const trimmed = name.trim();
  if (!trimmed || trimmed === "-" || trimmed.toLowerCase() === "no data available") {
    return false;
  }

  if (email && trimmed.toLowerCase() === email.toLowerCase()) {
    return false;
  }

  return trimmed.indexOf("@") === -1;
}

function splitFullName(fullName) {
  const normalized = typeof fullName === "string" ? fullName.trim().replace(/\s+/g, " ") : "";
  if (!normalized) {
    return { firstName: "", lastName: "" };
  }

  const parts = normalized.split(" ");
  return {
    firstName: parts[0] || "",
    lastName: parts.slice(1).join(" "),
  };
}

function getStructuredName(order) {
  const rawSession = order && order.rawSession ? order.rawSession : {};
  const customerDetails = rawSession.customer_details || order.customer_details || {};
  const shipping = rawSession.shipping || order.shipping || {};
  const billing = rawSession.billing_details || order.billing_details || {};

  return (
    customerDetails.name ||
    shipping.name ||
    billing.name ||
    ""
  );
}

function buildAddUserPrefillFromOrder(order) {
  const email = normalizePrefillEmail(
    (order && (order.Email || order.email)) ||
    (order && order.rawSession && order.rawSession.customer_details && order.rawSession.customer_details.email) ||
    (order && order.rawSession && order.rawSession.customer_email) ||
    "",
  );
  const structuredName = getStructuredName(order);
  const fallbackName = order && (order.CustomerName || order.customerName);
  const displayName = structuredName || (isUsableName(fallbackName, email) ? fallbackName : "");
  const names = splitFullName(displayName);

  return {
    email,
    firstName: names.firstName,
    lastName: names.lastName,
  };
}

function getLinkExistingUserSuccessMessage(result) {
  const email = result && result.secondaryEmail ? result.secondaryEmail : "";

  switch (result && result.secondaryEmailStatus) {
    case "added":
      return `User linked successfully. Payment email ${email} was added as a secondary payment email.`;
    case "already_exists":
      return `User linked successfully. Payment email ${email} is already associated with this member.`;
    case "primary_email":
      return "User linked successfully. The Stripe payment email already matches the member's primary email.";
    default:
      return "User linked successfully.";
  }
}

function getAddUserOrderLinkSuccessMessage(createdUser, submittedUser) {
  const email =
    (createdUser && createdUser.email) ||
    (submittedUser && submittedUser.user && submittedUser.user.email) ||
    "";

  return email
    ? `User created successfully for ${email} and linked to this order.`
    : "User created and order linked successfully.";
}

module.exports = {
  buildLinkExistingUserPayload,
  buildAddUserPrefillFromOrder,
  canLinkExistingUser,
  formatSecondaryEmails,
  getAddUserOrderLinkSuccessMessage,
  getLinkExistingUserSuccessMessage,
  getOrderLocalId,
  normalizeUserSearchResults,
  splitFullName,
};
